import React from "react";
import { FaFilter, FaPlus, FaEllipsisV, FaArrowUp } from "react-icons/fa";
import { MdRadioButtonUnchecked } from "react-icons/md";

const EmployerJobs = () => {
  return (
    <div className="flex-1 bg-[#f9fafb] p-6 min-h-screen">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold text-gray-800">Jobs</h1>
        <button className="text-blue-600 text-sm hover:underline">
          Post a Job Below to Start Your 2-Day FREE Trial!
        </button>
      </div>

      {/* Filters */}
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <select className="border border-gray-300 rounded px-3 py-1 text-sm bg-white shadow-sm">
          <option>All Jobs</option>
        </select>
        <span className="px-2 py-1 text-xs rounded-full bg-gray-100 text-gray-700">All</span>
        <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700">Active (0)</span>
        <span className="px-2 py-1 text-xs rounded-full bg-orange-100 text-orange-600">Draft</span>
        <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-600">Closed</span>
        <button className="ml-auto flex items-center gap-1 text-sm px-3 py-1 border border-gray-300 bg-white rounded shadow-sm">
          <FaFilter />
          All Filters
        </button>
      </div>

      {/* Banner */}
      <div className="bg-yellow-100 text-yellow-800 text-sm px-4 py-3 rounded border border-yellow-300 mb-4">
        Your Fixture Builder job is still waiting to be distributed...{" "}
        <a href="#" className="text-blue-600 font-medium hover:underline">
          Start your FREE trial to begin collecting candidates today!
        </a>
      </div>

      {/* Job Listing */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="px-4 py-3 flex items-center gap-3 border-b">
          <input type="checkbox" className="w-4 h-4" />
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h2 className="text-blue-700 font-semibold text-sm cursor-pointer hover:underline">
                Fixture Builder
              </h2>
              <span className="text-gray-500 text-sm">- Toronto, ON</span>
            </div>
            <p className="text-xs text-gray-500">
              clikkle · Created 4/18/25 by S Graham
            </p>
          </div>
          <div className="text-sm text-orange-600 font-semibold">DRAFT</div>
        </div>

        <div className="flex items-center justify-between px-4 py-2">
          <div className="relative inline-block text-left">
            <button className="flex items-center gap-2 border px-3 py-1 text-sm rounded bg-white text-gray-700 shadow-sm hover:bg-gray-50">
              Manage <FaEllipsisV className="text-xs" />
            </button>
          </div>
          <button className="flex items-center gap-2 px-3 py-1 bg-black text-white text-sm rounded shadow hover:bg-green-700">
            <FaArrowUp />
            Post Job
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployerJobs;
